import { render, staticRenderFns } from "./BindBankCard.vue?vue&type=template&id=1f6fc722&scoped=true"
import script from "./BindBankCard.vue?vue&type=script&lang=js"
export * from "./BindBankCard.vue?vue&type=script&lang=js"
import style0 from "./BindBankCard.vue?vue&type=style&index=0&id=1f6fc722&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6fc722",
  null
  
)

export default component.exports